import Noentities from '@/assets/images/no-agendas.png'

export const BLOCK_MESSAGES = {
  expiredDemo: {
    title: 'Tu prueba gratuita ha finalizado',
    subTitle: 'La prueba gratuita lamentablemente llegó a su fin, pero desde Calu queremos que sigas con nosotros.',
    img: Noentities,
    text: ' Si bien tu cuenta se bloqueó temporalmente, te invitamos a extender tu suscripción contactándote con nosotros',
    wappNum: 'https://wa.me/5491124064600',
  },
  blocked: {
    title: 'Tu suscripción se encuentra vencida',
    subTitle: 'Tu periodo de suscripción llegó a su fin, pero desde Calu queremos que sigas con nosotros',
    img: Noentities,
    text: 'Si bien tu cuenta se bloqueó, te invitamos a reactivar tu suscripción contactándote con nosotros',
    wappNum: 'https://wa.me/5492216175785',
  },
  unsubscribed: {
    title: 'Tu suscripción se ha cancelado',
    subTitle: 'Tu suscripción ha sido cancelada, pero desde Calu queremos que sigas con nosotros',
    img: Noentities,
    text: 'Si bien tu cuenta se bloqueó, te invitamos a reactivar tu suscripción contactándote con nosotros',
    wappNum: 'https://wa.me/5492216175785',
  },
}

export default BLOCK_MESSAGES
